exports.install=function (Vue,opt) {
    Vue.prototype.request=function(url,fn) {
    var r = new XMLHttpRequest();
    r.open('GET', url);
    r.responseType = 'text';
    r.send();
    r.onload = function (e) {
      var json = JSON.parse(e.target.response);
      fn(json);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js